import { Link } from "react-router-dom"
import { products } from "../../data/products"
import ProductCard from "../products/ProductCard"

export default function FeaturedProducts() {
const featuredProducts = products
.filter((product) => product.featured)
.slice(0, 8)

return (
<section className="py-20 lg:py-28 bg-gray-50">
<div className="container mx-auto px-4 lg:px-8">

    {/* Header */}
    <div className="max-w-3xl mx-auto text-center mb-14">
      <span className="inline-block text-sm font-semibold uppercase tracking-[0.2em] text-blue-600">
        Produits Vedettes
      </span>

      <h2 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900">
        Les produits les plus demandés
      </h2>

      <p className="mt-5 text-gray-600 leading-relaxed">
        Une sélection de nos références les plus appréciées par les
        professionnels du textile, de la confection, de la mercerie
        et de l’ameublement.
      </p>
    </div>

    {/* Produits */}
    <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-4">
      {featuredProducts.map((product) => (
        <ProductCard
          key={product.id}
          product={product}
        />
      ))}
    </div>

    {/* CTA */}
    <div className="mt-14 text-center">
      <Link
        to="/produits"
        className="inline-flex items-center justify-center px-8 py-4 rounded-xl bg-gray-900 text-white font-semibold hover:bg-black transition duration-300"
      >
        Voir tous les produits
      </Link>
    </div>

  </div>
</section>

)
}